import React, { createContext, useContext, useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/nav-bar/NavBarContext.tsx
const NavBarContext = createContext(void 0);
const NavBarProvider = ({ children }) => {
	const [backButtonDisabled, setBackButtonDisabled] = useState(false);
	const [backOverrideState, setBackOverrideState] = useState({ overrideFn: null });
	return /* @__PURE__ */ jsx(NavBarContext.Provider, {
		value: {
			backOverrideState,
			setBackOverrideState,
			backButtonDisabled,
			setBackButtonDisabled
		},
		children
	});
};
const useNavBar = () => {
	const context = useContext(NavBarContext);
	if (!context) throw new Error("useNavBar must be used within a NavBarProvider");
	return context;
};
const useConditionalBackOverride = (overrideFn, condition) => {
	const { setBackOverrideState } = useNavBar();
	useEffect(() => {
		if (condition) setBackOverrideState({ overrideFn });
		return () => setBackOverrideState({ overrideFn: null });
	}, [
		condition,
		overrideFn,
		setBackOverrideState
	]);
};
const useDisableBackButton = (disabled) => {
	const { setBackButtonDisabled } = useNavBar();
	useEffect(() => {
		if (disabled) setBackButtonDisabled(true);
		return () => setBackButtonDisabled(false);
	}, [disabled, setBackButtonDisabled]);
};

//#endregion
export { NavBarContext, NavBarProvider, useConditionalBackOverride, useDisableBackButton, useNavBar };